class Announcement extends HTMLElement {
    constructor() {
        super();

    }

    connectedCallback() {
        const swiper = new Swiper(this.querySelector('.swiper'), {
            direction: 'horizontal',
            loop: true,
            autoplay: {
                delay: Number(this.getAttribute('data-delay')) || 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
        });
    }
}

customElements.define('announcement-bar', Announcement);